import axios from './axios-json';
import { errorToast } from './toasts';
import { getCookie } from 'tiny-cookie';
import { trackUserLogout, getDatadogUser } from './lib/datadogRum';

const errorToastDuration = 3000;

const tokenDom = document.querySelector('meta[name=csrf-token]');
if (tokenDom) {
  axios.defaults.headers.common['X-CSRF-Token'] = tokenDom.getAttribute('content');
}

const jwtCookieName = window['__JWT_COOKIE_NAME__'] || 'jwt';
const jwtToken = getCookie(jwtCookieName);

if (jwtToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
} else if (window.auth) {
  axios.defaults.headers.common['X-User-Email'] = window.auth.email;
  axios.defaults.headers.common['Authorization'] = `Bearer ${window.auth.authentication_token}`;
}

function redirectToRoot() {
  window.location.href = '/';
}

function authenticationErrorHandler() {
  const currentUser = getDatadogUser();
  trackUserLogout(currentUser?.id);

  return errorToast('You are not authenticated! Redirecting to login page....', {
    duration: errorToastDuration,
    onComplete() {
      redirectToRoot();
    },
  });
}

function authorizationErrorHandler() {
  return errorToast('You are not authorized to perform this action.', {
    duration: errorToastDuration,
    onComplete() {
      redirectToRoot();
    },
  });
}

// Interceptors

axios.interceptors.request.use(
  config => {
    const latitude = sessionStorage.getItem('latitude');
    const longitude = sessionStorage.getItem('longitude');

    if (latitude && longitude) {
      config.headers = { ...config.headers, 'x-latitude': latitude, 'x-longitude': longitude };
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    switch (error.response?.status) {
      case 401:
        return authenticationErrorHandler();
      case 403:
        return authorizationErrorHandler();
      default:
        return Promise.reject(error);
    }
  }
);

export default axios;
